import { useLocation } from "react-router-dom";

const useSegment = () => {
  const {pathname} = useLocation();
  if (pathname === "/") return pathname;

  return pathname.substring(pathname.lastIndexOf("/") + 1);
}

export default useSegment;